import { useState } from 'react'
import { C, R, F } from '../../lib/designTokens'
import { useAsyncData } from './useProductKnowledgeData'
import * as pkd from '../../services/productKnowledgeDetailService'
import { Tag } from './ProductKnowledgeParts'

// All terms (the glossary), alphabetical, with a quick filter over English and Arabic.
export default function ProductKnowledgeGlossary({ onOpenItem }) {
  const { data, loading, error, reload } = useAsyncData(() => pkd.listTerms(), [])
  const [q, setQ] = useState('')

  if (loading) return <div style={{ color: C.sub, fontSize: F.body }}>Loading… / جارٍ التحميل…</div>
  if (error) return (
    <div>
      <p style={{ color: C.red, fontSize: F.body }}>Could not load the glossary. / تعذّر تحميل المصطلحات.</p>
      <button onClick={reload} style={{ fontSize: F.caption, padding: '6px 14px', borderRadius: R.btn, border: `1px solid ${C.border}`, background: C.surface, cursor: 'pointer' }}>Retry / إعادة المحاولة</button>
    </div>
  )

  const terms = Array.isArray(data) ? data : []
  const needle = q.trim().toLowerCase()
  const shown = needle
    ? terms.filter(t => [t.name_en, t.name_ar, t.short_en, t.short_ar].some(x => x && x.toLowerCase().includes(needle)))
    : terms

  return (
    <div style={{ maxWidth: 720 }}>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="Filter terms… / تصفية المصطلحات…"
        style={{ width: '100%', fontSize: F.title, padding: '10px 14px', borderRadius: R.input, border: `1px solid ${C.border}`, outline: 'none', fontFamily: 'inherit', background: C.surface, marginBottom: 14 }} />
      {terms.length === 0 && <div style={{ color: C.sub, fontSize: F.body }}>No terms yet. / لا توجد مصطلحات بعد.</div>}
      {terms.length > 0 && shown.length === 0 && <div style={{ color: C.sub, fontSize: F.body }}>No matching terms. / لا توجد مصطلحات مطابقة.</div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {shown.map(t => (
          <button key={t.key} onClick={() => onOpenItem('term', t.key)}
            style={{ textAlign: 'left', padding: '10px 14px', borderRadius: R.card, border: `1px solid ${C.border}`, background: C.surface, cursor: 'pointer', fontFamily: 'inherit' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <span style={{ fontSize: F.bodyLg, fontWeight: 700, color: C.ink }}>{t.name_en}</span>
              {t.name_ar && <span dir="rtl" style={{ fontSize: F.body, color: C.sub }}>{t.name_ar}</span>}
              {t.category && <Tag>{t.category}</Tag>}
            </div>
            {t.short_en && <div style={{ fontSize: F.body, color: C.ink2, marginTop: 3, lineHeight: 1.4 }}>{t.short_en}</div>}
          </button>
        ))}
      </div>
    </div>
  )
}
